import { gql } from '@apollo/client';

export const GET_PICKUP_WORK_START_INFO = gql`
  query GetPickupWorkStartInfo {
    getPickupWorkStartInfo {
      hasTodayTask
      pendingTaskId
      startWorkEnabled
      todayAppointmentCount
      yesterdayFinishedAppointmentCount
      yesterdayWorkingMinutes
    }
  }
`;

export interface PickupWorkStartInfo {
  /** 今日是否有未跑完的任务（不论是否已开始作业） */
  /**
   * 本司机是否命中「开始揽收」灰度（后端按司机账号所属 hub 判定）。
   * false 时**不渲染启动页**，直接进任务列表——非灰度 hub 保持改造前的行为。
   */
  startWorkEnabled: boolean;
  hasTodayTask: boolean;
  /** 当前待开始作业的任务 ID；为空表示今日任务都已开始，或今日无任务 */
  pendingTaskId: string | null;
  /** 今日情况·揽收地址数 */
  todayAppointmentCount: number;
  /** 昨日回顾·揽收地址数；为空表示昨日无任务，整块隐藏 */
  yesterdayFinishedAppointmentCount: number | null;
  /** 昨日回顾·耗时（分钟）；为空时显示 - */
  yesterdayWorkingMinutes: number | null;
}

export interface GetPickupWorkStartInfoResponse {
  getPickupWorkStartInfo: PickupWorkStartInfo;
}
